import React from 'react';
import { LogoImageWrapper, LogoWrapper } from './HeaderLogo.style';
import Logo from './Logo';
import { generateHomePageUrl } from '../../../../common/helpers/routing/landingPageUrlGenerator';

function HeaderLogo() {
  return (
    <LogoWrapper>
      <LogoImageWrapper href={generateHomePageUrl()}>
        <Logo />
      </LogoImageWrapper>
    </LogoWrapper>
  );
}

export default HeaderLogo;
